module.exports = __webpack_public_path__ + "static/media/open-link.760f2303.svg";